import { render, staticRenderFns } from "./index_phone.vue?vue&type=template&id=5c331188&scoped=true"
import script from "./index_phone.vue?vue&type=script&lang=js"
export * from "./index_phone.vue?vue&type=script&lang=js"
import style0 from "./index_phone.vue?vue&type=style&index=0&id=5c331188&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c331188",
  null
  
)

export default component.exports